import styled, { css } from 'styled-components'
import { loadingAnimationCss, shadowCss } from '../styles'
import { getColor } from '../colors'

export const PreloadLine = styled.div`
	background: #cecece;
	border-radius: 5px;
	${loadingAnimationCss}
`
export const PageWrapper = styled.div`
	width: 100%;
	margin: 90px 0 40px;
`

export const DefaultWrapper = styled.div`
	background: #ffffff;
	border-radius: 5px;
	${shadowCss}
	padding: 20px;
`

export const Line = styled.div<{ small?: boolean }>`
	width: 100%;
	background: ${getColor(x => x.ghost.main)};
	${({ small = true }) =>
		small
			? css`
					height: 1px;
			  `
			: css`
					height: 10px;
			  `}
`
